import { createContext, useContext } from "react";

export type NavigationContextType = {
    balanceSectionRef: React.MutableRefObject<HTMLElement>
    journeySectionRef: React.MutableRefObject<HTMLElement>
    bookingSectionRef: React.MutableRefObject<HTMLElement>
};

const NavigationContext = createContext<NavigationContextType | undefined>(undefined);
export const NavigationContextProvider = NavigationContext.Provider;

export function useNavigationContext() {
    const ctx = useContext(NavigationContext);
    if (!ctx) throw new Error("useNavigationContext must be used within a <NavigationProvider />");
    return ctx;
}